import {configureStore} from "@reduxjs/toolkit";
import {tenantsSlice} from "./tenantsSlice";
import {plansSlice} from "./plansSlice";
import {promotionsSlice} from "./promotionsSlice";
import {analyticsSlice} from "./analyticsSlice";
import {invoicesSlice} from "./invoicesSlice";
import {sentEmailsSlice} from "./sentEmailsSlice";

export const store = configureStore({
  reducer: {
    tenants: tenantsSlice.reducer,
    plans: plansSlice.reducer,
    promotions: promotionsSlice.reducer,
    analytics: analyticsSlice.reducer,
    invoices: invoicesSlice.reducer,
    sentEmails: sentEmailsSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
